<div class="modal-body">
  <div class="content">
    <div class="top">
      <h4 translate>sales.deal-id-explaination-modal.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <img src="assets/img/how-to-get-deal-id.png" alt="" class="img">
    <div class="buttons-container">
      <button class="vox-btn vox-btn-secondary-dark-grey" (click)="close()"
        translate>sales.deal-id-explaination-modal.close</button>
    </div>
  </div>
</div>